module.exports = __webpack_public_path__ + "media/images/illustrations/confetti-coins-094f1863f57714247ae572c646cbbc15.svg";